module.exports = __webpack_public_path__ + "img/blue_159.acb680ec.png";